import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import BoardMeetingDateModalUI from './BoardMeetingDateModalUI'

class BoardMeetingDateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            // form events
            submitted: false,
            // form field
            boardMeetingDate: '',
            boardMeetingDateError: null
        }
    }

    render() {
        return (
            <BoardMeetingDateModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                // modes
                updateMode={this.props.updateMode}
                submitted={this.state.submitted}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.props.onCancelClick}
                // form fields
                boardMeetingDate={this.state.boardMeetingDate}
                onBoardMeetingDateChange={(boardMeetingDate) => { this.setState({ boardMeetingDate: boardMeetingDate }) }}
                boardMeetingDateError={this.state.boardMeetingDateError}
                setBoardMeetingDateError={(error) => { this.setState({ boardMeetingDateError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    componentDidUpdate(prevProps) {
        let loan = this.props.loan
        if (!loan)
            return
        if (prevProps.loan && prevProps.loan.loanId == loan.loanId)
            return

        this.setState({
            boardMeetingDate: loan.resolutionSign.boardMeetingDateISO
        })
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.put(this.props.context,
            `/api/su/loans/${this.props.loan.loanId}/documents/boardMeetingDate`,
            this.onSubmitCallback, {
            boardMeetingDate: this.state.boardMeetingDate,
        }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onCancelClick()
                this.props.onRefreshClick()
            }, 1000)
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default withRouter(BoardMeetingDateModalSF)
